'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/RS-rydges2018-docker/RS-rydges2018-docker/wp-content/themes/indcoll-standalone/node_modules/axios/lib/cancel/isCancel.js
// module id = 20
// module chunks = 0